"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var $ = require("jquery");
var ko = require("knockout");
var validatedViewModel_1 = require("./base/validatedViewModel");
var richContentUtils_1 = require("../utils/richContentUtils");
var ajaxUtils_1 = require("../../app/utils/ajaxUtils");
var ViewModel = (function (_super) {
    __extends(ViewModel, _super);
    function ViewModel(options) {
        var _this = this;
        _super.call(this, options);
        this.userNoteMaxLength = 500;
        this.userNote = ko.observable().extend({
            maxLength: this.userNoteMaxLength
        });
        this.userNoteHint = ko.pureComputed(function () {
            var userNote = _this.userNote() || "";
            return userNote.length + "/" + _this.userNoteMaxLength;
        });
        this.profileId = options.profileId;
        this.userNote(options.userNote);
        richContentUtils_1.default.processHtml(".about-me, .comments");
        var mySwiper = app.f7.swiper(".work-slider", {
            slidesPerView: "auto",
            speed: 300,
            spaceBetween: 8,
            slidesPerGroup: 3,
            grabCursor: true,
            scrollbar: ".swiper-scrollbar"
        });
        $(".autoresize-textarea").each(function () {
            this.style.height = this.scrollHeight + "px";
            this.style.overflowY = "hidden";
        }).on("input", function () {
            this.style.height = "auto";
            this.style.height = this.scrollHeight + "px";
        });
    }
    ViewModel.prototype.saveUserNote = function () {
        var _this = this;
        if (this.validation !== undefined && !this.validation.isValid()) {
            this.validation.errors.showAllMessages();
            return;
        }
        ;
        if (this.processing())
            return;
        this.processing(true);
        this.errorMessages([]);
        var data = {
            targetUserId: this.profileId,
            note: this.userNote()
        };
        ajaxUtils_1.AjaxUtils.post("profile/updateUserNote", data)
            .done(function (result) {
            if (result.isSuccessful) {
                alert(result.messages[0]);
            }
            else {
                alert(result.messages[0]);
            }
        }).always(function () {
            _this.processing(false);
        });
    };
    return ViewModel;
}(validatedViewModel_1.default));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ViewModel;
//# sourceMappingURL=profileIndex.js.map